import Swiper, {Autoplay, Navigation} from 'swiper';

Swiper.use([Autoplay, Navigation]);

let offerClassName = '.offer-what-we-do-content-left .offer-menu-container';
let currentActivClass = 0;

export default () => {
    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var offset = ($(target).offset().top - 120);
        $('html, body').animate({
            scrollTop: offset
        }, 'slow');
    });
    let offerContainer = document.querySelector(offerClassName);

    if (offerContainer) {

        let rect = offerContainer.getBoundingClientRect();
        let left = rect.left ;

        let navbar = document.querySelector(".navbar");
        let header = document.querySelector(".offer-header");
        let top = header.clientHeight + navbar.clientHeight + 20;
        const titlesOnRight = document.querySelectorAll(".offer-what-we-do-content-right > div");
        const titlesOnLeft = document.querySelectorAll(".offer-what-we-do-content-left-sidebar > ul > li");

        // sticky(offerClassName, top, left);
        // changeSticky(container, top, left, false);
        window.addEventListener('resize', () => {
            top = header.clientHeight + navbar.clientHeight + 20;
            let offerContent = document.querySelector('.offer-what-we-do-content');
            const offerContentLeft = offerContent.getBoundingClientRect().left ;
            if (Math.abs(offerContentLeft - left) > 25){
                left = offerContentLeft;
            }

            sticky(offerClassName, top, left);
        });

        window.addEventListener('scroll', () => {
            sticky(offerClassName, top, left);
            if (document.body.clientWidth > 1200){
                const activeClass = findActiveTitle(titlesOnRight);

                if (currentActivClass != activeClass) {
                    titlesOnLeft[currentActivClass].classList.remove("active");
                    titlesOnLeft[activeClass].classList.add("active");
                    currentActivClass = activeClass;
                }
            }
        });
    }

    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var offset = ($(target).offset().top - 120);
        $('html, body').animate({
            scrollTop: offset
        }, 'slow');
    });
}



function findActiveTitle(tab) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    let activeClass = tab[0];
    let activeIndex = 0;
    let minDistance = scrollTop - activeClass.offsetTop - 320;

    tab.forEach((el, index) => {
        const distance = scrollTop - el.offsetTop - 320;
        if (Math.abs(distance) < Math.abs(minDistance)) {
            activeClass = el;
            activeIndex = index;
            minDistance = distance;
        }
    });

    return activeIndex;

}


let sticky = (className, top, left) => {
    let container = document.querySelector(className);
    let content = document.querySelector('.offer-what-we-do');
    if (container && document.body.clientWidth > 1200){
        let max = content.clientHeight;
        if (window.scrollY + 70 < top) {
            changeSticky(container, top, left, false, false);
        } else if (window.scrollY > max - 70) {
            changeSticky(container, top, left, true, true);
        } else {
            changeSticky(container, top, left, true, false);
        }
    }
    if (container && document.body.clientWidth < 1200){
        changeSticky(container, top, left,false, false,true);
    }
}

let changeSticky = (container, top, left, makeSticky, hide,makeStatic) => {
    container.style.left = null;
    container.style.top = null;
    container.style.position = null;
    container.style.opacity = 1;
    container.style.pointerEvents = 'auto';


    if (makeSticky) {
        let header = document.querySelector(".offer-header");
        top = top - header.clientHeight;
        container.style.left = left + 'px';
        container.style.top = top + 'px';
        container.style.position = 'fixed';
    }

    if (hide) {
        container.style.opacity = 0;
    }
    if (makeStatic){
        container.style.opacity = 1;
        container.style.position = "static";
    }
}
